import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '0px 8px',
  },
  agent: {
    padding: '30px',
  },
  agent_header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
  },
  agent_header_title: {
    display: 'flex',
    alignItems: 'center',
    placeItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
  },
  agent_table: {
    marginTop: '20px',
  },
  agent_table_row: {
    cursor: 'pointer',
  },
  agent_table_first_cell: {
    paddingLeft: '0px',
  },
  agent_table_sort_cell: {
    cursor: 'pointer',
    display: 'flex',
    gap: 4,
    paddingLeft: '0px',
  },
  agent_table_popover: {
    width: '180px',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    boxShadow: '0px 16px 24px -4px rgba(124, 143, 172, 0.25)',
  },
  agent_table_popover_button: {
    gap: '11px',
    justifyContent: 'start',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#F6F8FC',
    },
  },
  agent_table_popover_button_open: {
    color: '#1875FF',
    '& svg': {
      marginLeft: '2px',
      marginRight: '4px',
    },
  },
  campaign: {
    boxShadow: 'none',
  },
  campaign_header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  campaign_search_field: {
    width: '100%',
    maxWidth: 300,
    minWidth: 200,
  },
  campaign_header_title: {
    display: 'flex',
    alignItems: 'center',
    placeItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
  },
  campaign_table: {
    marginTop: '24px',
    minWidth: '860px',
  },
  campaign_table_row: {
    cursor: 'pointer',
    '& > td': {
      borderBottom: `1px solid ${theme.palette.extendedGrey?.lighter}`,
      height: '56px',
    },
  },
  campaign_table_first_cell: {
    minWidth: '220px',
  },
  campaign_table_created_at_cell: {
    minWidth: '160px',
  },
  campaign_table_status_cell: {
    minWidth: '125px',
  },
  campaign_table_startstop_cell: {
    minWidth: '115px',
  },
  campaign_type_badge: {
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '15px',
    borderWidth: '1px',
    borderStyle: 'solid',
    backgroundColor: theme.palette.background.paper,
  },
  campaign_type_badge_inbound: {
    padding: '3.5px 10px 3.5px 4px',
    borderColor: '#FA896B80',
  },
  campaign_type_badge_outbound: {
    padding: '3.5px 4px 3.5px 10px',
    borderColor: '#1875FF80',
  },
  campaign_type_badge_icon: {
    borderRadius: '100%',
    '& svg path:first-child': { opacity: 0 },
  },
  campaign_type_badge_icon_inbound: {
    backgroundColor: '#FBF2EF',
  },
  campaign_type_badge_icon_outbound: {
    backgroundColor: '#ECF2FF',
  },
  campaign_type_badge_label: {
    fontSize: '12px',
  },
  campaign_type_badge_label_inbound: {
    fontSize: '12px',
    color: '#FA896B',
  },
  campaign_type_badge_label_outbound: {
    color: '#1875FF',
  },
  campagin_table_sort_cell: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 6,
  },
  campagin_table_sort_icon: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: 'rgba(234, 239, 244, 1)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  campagin_table_th: {
    flexBasis: 'min-content',
    textWrap: 'nowrap',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'none',
  },
  campaign_pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 12,
    flexWrap: 'wrap',
  },
  pagination_text: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  pagination_controls: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  rows_per_page: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  action_menu: {
    minWidth: 156,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: 8,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.extendedGrey?.lighter}`,
    borderRadius: 8,
    boxShadow: theme.shadows[8],
  },
  action_menu_button: {
    justifyContent: 'flex-start',
    gap: 10,
    borderRadius: 6,
    width: '100%',
  },
  subtitle: {
    fontSize: 18,
  },
  campaign_name_textfield: {
    '&::placeholder': {
      color: 'red',
      opacity: 1,
    },
  },
  campaign_type_select: {
    width: '100%',
    [`> svg`]: {
      marginRight: '4px',
    },
  },
}));
